import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_SHOP_BY_LIST_ELIGIBILITY = apiPromiseTypes(
  'intelligent-shopping-experience-eligibility',
  'get',
);

export const GET_SHOP_BY_LIST_EXTRACTED_SEARCH_TERMS = apiPromiseTypes(
  'intelligent-shopping-experience-search-terms',
  'post',
);

export const GET_SHOP_BY_LIST_SUGGESTIONS = apiPromiseTypes(
  'intelligent-shopping-experience-suggestions',
  'post',
);

export const FETCH_VIEW_ALL_MODAL_SUGGESTIONS = apiPromiseTypes(
  'intelligent-shopping-experience-view-all-modal-suggestions',
  'post',
);

export const CREATE_CROSS_CHANNEL_UPLOAD_SESSION = apiPromiseTypes(
  'cross-channel-upload-session',
  'post',
);

export const RESET_VIEW_ALL_MODAL_SUGGESTIONS = 'RESET_VIEW_ALL_MODAL_SUGGESTIONS';

export const UPDATE_SHOP_BY_LIST_SEARCH_TERM = 'UPDATE_SHOP_BY_LIST_SEARCH_TERM';

export const ADD_VIEW_ALL_MODAL_PRODUCT_TO_CAROUSEL = 'ADD_VIEW_ALL_MODAL_PRODUCT_TO_CAROUSEL';

export const GET_SHOP_BY_LIST_ESTIMATED_PRICE = apiPromiseTypes(
  'shop-by-list-pricing2-priced-products',
  'post',
);
